export default __webpack_public_path__ + "static/media/addIcon.778a5cca.svg";